export const defaultSummary = {
  providerData: 0,
  itemData: 0,
  ratePlanData: 0,
};

export const initialProcessList = [];

export const initialHistoryData = { imports: [] };
